import { Form, InputNumber } from 'antd';
import './PricingInputField.scss';

interface IpricingInputFieldProps {
  dataName: string;
  label: string;
  suffixSymbol: string;
  placeholder: string;
  componentSize?: string;
  initialValue?: number;
  currentValue?: number;
  isRequired?: boolean;
  isDisabled?: boolean;
  maxValue?: number;
}

const PricingInputField = (props: IpricingInputFieldProps) => {
  const {
    dataName,
    label,
    suffixSymbol,
    placeholder,
    componentSize,
    initialValue,
    currentValue,
    isRequired,
    isDisabled,
    maxValue
  } = props;
  const sizeStyles = componentSize ? componentSize : '';
  const unfilledStyles = !!currentValue ? '' : 'unfilled';
  const disabledStyles = isDisabled ? 'disabled' : '';

  const numberFormater = new Intl.NumberFormat('es-MX');
  const formatPrice = (value?: string) => `${value ? numberFormater.format(+value) : 0} ${suffixSymbol}`;
  const parsePrice = (value?: string) => value!.replace(suffixSymbol, '').replaceAll(',', '');

  return (
    <div className={`pricingInputField ${sizeStyles} ${unfilledStyles} ${disabledStyles}`}>
      <label className="sizePricingInputField">{label}</label>
      <Form.Item
        name={dataName}
        initialValue={initialValue}
        rules={[{ required: isRequired, message: isRequired ? 'Este campo es requerido' : '' }]}
      >
        <InputNumber
          formatter={formatPrice}
          parser={parsePrice}
          className={`pricingInput ${unfilledStyles} ${disabledStyles}`}
          placeholder={placeholder}
          disabled={!!isDisabled}
          min={'0'}
          max={maxValue ? `${maxValue}` : undefined}
        />
      </Form.Item>
    </div>
  );
};

export default PricingInputField;
